import { MY_AUCTION_TYPES } from './constants';

export function isValidType(type: string): boolean {
  return MY_AUCTION_TYPES.includes(type);
}
